import { css } from '@emotion/react'

export const root = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`

export const row = css`
  flex-direction: row;
`
